module.exports = __webpack_public_path__ + "img/extendedhours.9498c701.svg";